module.exports = __webpack_public_path__ + "img/slide2.309b62ca.png";